import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend
} from 'recharts';
import { Loader2 } from 'lucide-react';
import { fetchData, deleteData, activateData } from '../../apiService';
import { useAuth } from '../../AuthContext';

const CategorySalesChart = () => {
  const [data, setData] = useState([]);
  const [summaryData, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

  useEffect(() => {
    const fetchSalesData = async () => {

      // Get current date
      const toDateObj = new Date();
      const toDate = toDateObj.toISOString().split('T')[0]; // Format: YYYY-MM-DD

      // Get date of same day previous month
      const fromDateObj = new Date(toDateObj);
      fromDateObj.setMonth(fromDateObj.getMonth() - 1);
      const fromDate = fromDateObj.toISOString().split('T')[0];

      try {
        const response = await fetchData('ReportApi', `/SalesCategoryWise/${fromDate}/${toDate}/${companyId}`, token);
        if (response.responseCode === '1111') {
          //setDataItem(response.response_data);
          const top10 = [...response.response_data]
            .sort((a, b) => b.SaleQuantity - a.SaleQuantity)
            .slice(0, 10);
          setData(top10);
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching sales data:', error);
      }
    };


    const fetchSalesPaymentStatus = async () => {
      const toDateObj = new Date();
      const toDate = toDateObj.toISOString().split('T')[0];

      const fromDateObj = new Date(toDateObj);
      fromDateObj.setMonth(fromDateObj.getMonth() - 1);
      const fromDate = fromDateObj.toISOString().split('T')[0];

      try {
        const response = await fetchData(
          'ReportApi',
          `/SalesPaymentStatus/${fromDate}/${toDate}/${companyId}`,
          token
        );

        if (response.responseCode === '1111') {
          const data = response.response_data;

          if (data.length > 0) {
            const { SaleAmount, PaidAmount } = data[0]; // Assuming only one object
            const unpaid = SaleAmount - PaidAmount;

            const chartData = [
              { name: 'Paid', value: PaidAmount },
              { name: 'Unpaid', value: unpaid }
            ];

            setSummaryData(chartData);
            setLoading(false);
          }
        }
      } catch (error) {
        console.error('Error fetching sales data:', error);
      }
    };


    fetchSalesData();
    fetchSalesPaymentStatus();
  }, []);


  const COLORS = [
    "#1e3a8a", // dark blue
    "#2563eb", // blue
    "#60a5fa", // light blue
    "#93c5fd", // sky blue
    "#d1d5db", // gray
    "#22c55e", // green
    "#f97316", // orange
    "#dc2626"  // red
  ];
  return (
    // <div
    //   className="max-w-6xl mx-auto px-4"
    //   style={{
    //     fontFamily: 'monospace',
    //     color: '#1A1A1D',
    //     marginTop: '5px',
    //   }}
    // >
    //   {loading ? (
    //     <div className="flex justify-center items-center h-48 text-gray-400">
    //       <Loader2 className="animate-spin h-8 w-8 mr-2 text-indigo-500" />
    //       Loading chart...
    //     </div>
    //   ) : (
    //     <div className="flex flex-col md:flex-row gap-6">
    //       {/* Bar Chart Card */}
    //       <div className="w-full md:w-full bg-gray-50 rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">

    //         <h5
    //           className="text-gray-800 mb-5 font-semibold flex items-center gap-3"
    //           style={{
    //             fontFamily: 'monospace',
    //             fontSize: '14px',
    //             textTransform: 'uppercase',
    //           }}
    //         >
    //           📊 Category-wise Sale Quantity (Top 10 Last Month)
    //         </h5>

    //         <ResponsiveContainer width="100%" height={230}>
    //           <BarChart
    //             data={data}
    //             margin={{ top: 15, right: 20, left: 0, bottom: 25 }}
    //           >
    //             <CartesianGrid strokeDasharray="4 4" vertical={false} stroke="#e5e7eb" />
    //             <XAxis
    //               dataKey="CategoryName"
    //               interval={0}
    //               tick={({ x, y, payload }) => (
    //                 <text
    //                   x={x}
    //                   y={y + 10}
    //                   textAnchor="middle"
    //                   fill="#374151"
    //                   fontSize={9}
    //                 >
    //                   {payload.value.split(" ").map((word, index) => (
    //                     <tspan key={index} x={x} dy={index === 0 ? 0 : 12}>
    //                       {word}
    //                     </tspan>
    //                   ))}
    //                 </text>
    //               )}
    //               height={60}
    //             />

    //             <YAxis tick={{ fontSize: 9, fill: '#4b5563' }} />
    //             <Tooltip
    //               contentStyle={{
    //                 backgroundColor: '#ffffff',
    //                 border: '1px solid #e5e7eb',
    //                 borderRadius: '8px',
    //                 fontFamily: 'monospace',
    //                 fontSize: '10px',}}
    //             />

    //             <defs>
    //               <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
    //                 <stop offset="0%" stopColor="#4f46e5" stopOpacity={0.9} />
    //                 <stop offset="100%" stopColor="#60a5fa" stopOpacity={0.7} />
    //               </linearGradient>
    //             </defs>

    //             <Bar
    //               dataKey="SaleQuantity"
    //               radius={[8, 8, 0, 0]}
    //               barSize={36}
    //             >
    //               {data.map((entry, index) => (
    //                 <Cell
    //                   key={`cell-${index}`}
    //                   fill={[
    //                     '#3b82f6', '#2563eb', '#60a5fa', '#93c5fd', '#bfdbfe',
    //                     '#1d4ed8', '#1e40af', '#1e3a8a', '#172554', '#6366f1'
    //                   ][index % 10]}
    //                 />
    //               ))}
    //             </Bar>
    //           </BarChart>
    //         </ResponsiveContainer>
    //       </div>
    //     </div>
    //   )}

    // </div >
    <div
      className="max-w-6xl mx-auto px-4"
      style={{ fontFamily: 'monospace', color: '#1A1A1D', marginTop: '5px' }}
    >
      {loading ? (
        <div className="flex justify-center items-center h-48 text-gray-400">
          <Loader2 className="animate-spin h-8 w-8 mr-2 text-indigo-500" />
          Loading chart...
        </div>
      ) : (
        <div className="w-full bg-gray-50 rounded-2xl p-6 duration-300" style={{ cursor: 'pointer' }}>

          {/* Chart Title */}
          <h5
            className="text-gray-800 mb-5 text-center"
            style={{
              fontFamily: 'Segoe UI, sans-serif',
              fontSize: '12px',
              textTransform: 'uppercase',
              fontWeight: 'bolder',
            }}
          >
            📊 Category-wise Sale Quantity (Top 5 Last Month)
          </h5>

          <div className="flex flex-col gap-4 p-4 rounded-xl shadow-md" style={{ fontFamily: 'monospace', marginTop: '-40px', backgroundColor: "#0D1B2A", borderRadius: '20px' }}>
            {data.map((item, idx) => {
              const maxValue = Math.max(...data.map(d => d.SaleQuantity));
              const percentage = (item.SaleQuantity / maxValue) * 100;

              const colors = [
                "linear-gradient(90deg, #2563eb, #1d4ed8)", // blue
                "linear-gradient(90deg, #10b981, #059669)", // emerald
                "linear-gradient(90deg, #f59e0b, #d97706)", // amber
                "linear-gradient(90deg, #ef4444, #dc2626)", // red
                "linear-gradient(90deg, #8b5cf6, #7c3aed)"  // violet
              ];

              return (
                <div key={idx} className="flex items-center gap-2">
                  {/* Category Name */}
                  <span className="w-40 text-sm font-semibold text-white truncate" style={{ fontSize: '11px' }}>
                    {item.CategoryName}
                  </span>

                  {/* Bar */}
                  <div className="flex-1">
                    <div className="w-full bg-gray-100 rounded-full h-4 overflow-hidden shadow-inner">
                      <div
                        className="h-4 rounded-full transition-all duration-700 ease-in-out"
                        style={{
                          width: `${percentage}%`,
                          background: colors[idx % colors.length],
                        }}
                      ></div>
                    </div>
                  </div>

                  {/* Value */}
                  <span className="w-16 text-xs text-white text-right">
                    {item.SaleQuantity.toLocaleString()}
                  </span>
                </div>
              );
            })}
          </div>

        </div>
      )
      }
    </div >

  );

};

export default CategorySalesChart;
